/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MeUpdateDeviceTokenResponse } from "./MeUpdateDeviceTokenResponse";

export type MeUpdateDeviceTokenResponseApiRespoonse = {
  data?: MeUpdateDeviceTokenResponse;
  status?: MeUpdateDeviceTokenResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace MeUpdateDeviceTokenResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
